import { el } from "./dom.js";
import { fmtCompact, fmtDur } from "./format.js";
import { api } from "../net/api.js";

/** Player profile: lifetime stats from the DB. */
export function profileScreen(onBack: () => void): HTMLElement {
  const screen = el("div", { class: "screen" });
  const panel = el("div", { class: "panel", style: "min-width:420px" });
  const body = el("div", { class: "hint", text: "loading…" });

  const stat = (label: string, value: string): HTMLElement =>
    el("div", { class: "stat-tile" },
      el("div", { class: "stat-val", text: value }),
      el("div", { class: "stat-label", text: label }),
    );

  void api.getStatsAndRank().then(({ stats: s, rank }) => {
    const kd = s.deaths > 0 ? (s.kills / s.deaths).toFixed(2) : String(s.kills);
    // RANK BANNER: tier name + level + progress toward the next level
    const banner = el("div", { class: "rank-banner" });
    if (rank) {
      const bar = el("div", { class: "rank-bar" });
      const fill = el("div", { class: "rank-bar-fill" });
      fill.style.width = `${Math.round(rank.frac * 100)}%`;
      fill.style.background = rank.color;
      bar.append(fill);
      const badge = el("div", { class: "rank-badge", text: rank.name });
      badge.style.color = rank.color;
      badge.style.borderColor = rank.color;
      banner.append(
        el("div", { class: "rank-row" },
          badge,
          el("div", { class: "rank-lvl", text: `LEVEL ${rank.level}` }),
        ),
        bar,
        el("div", { class: "rank-xp", text: `${s.levelInto ?? 0} / ${s.levelSpan ?? 0} XP  ·  ${s.xp ?? 0} lifetime` }),
      );
    }
    body.replaceChildren(
      banner,
      el("div", { class: "stat-grid" },
        stat("Kills", String(s.kills ?? 0)),
        stat("Deaths", String(s.deaths ?? 0)),
        stat("K/D", kd),
        stat("Wins", String(s.wins ?? 0)),
        stat("Matches", String(s.matches ?? 0)),
        stat("Headshots", String(s.headshots ?? 0)),
        stat("Best Tier", String((s.bestTier ?? 0) + 1)),
        stat("Playtime", fmtDur(s.playtimeS ?? 0)),
        // career marksmanship — accrues from matches finished after the
        // stats were introduced, so long-time accounts start from zero here
        stat("Accuracy", (s.shots ?? 0) > 0 ? `${Math.round(((s.hits ?? 0) / s.shots) * 100)}%` : "—"),
        stat("Damage", fmtCompact(s.damage ?? 0)),
        stat("Best Streak", String(s.bestStreak ?? 0)),
        stat("Longest Kill", (s.longestShot ?? 0) > 0 ? `${Math.round(s.longestShot)}m` : "—"),
        stat("Purge Rank", `⭐ ${s.purgeRank ?? 0}`),
        stat("Purge Best", `round ${s.purgeBestRound ?? 0}`),
      ),
    );
  }).catch((e) => (body.textContent = (e as Error).message));

  const back = el("button", { class: "ghost wide mt1", text: "Back" });
  back.onclick = onBack;

  panel.append(
    el("div", { class: "brand", text: "NEON PURGE" }),
    el("div", { class: "brand-sub", text: `${api.account?.username ?? ""} — CAREER` }),
    body,
    back,
  );
  screen.append(panel);
  return screen;
}
